export const NOTIFICATIONS_BAR_HEIGHT = '42px';
export const NOTIFICATIONS_BAR_SIDE_MARGIN = '5px';
export const NOTIFICATIONS_BAR_TOP_MARGIN = '6px';
export const NOTIFICATIONS_BAR_HEIGHT_WITH_MARGIN = '48px';
